import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

export const loggedInGuard: CanActivateFn = async (route, state) => {
  const router: Router = inject(Router);
  const authService = inject(AuthenticationService);

  // Only check authentication status if we don't have cached state
  // If cached state is false, we know user is not logged in, so skip API call
  const isLoggedIn = await authService.isLoggedIn();

  // TODO: check if route is present in @loginResponse.data.menuItems
  if (isLoggedIn) {
    return true;
  } else {
    // Redirect to login if not authenticated
    return router.navigate(['login']);
  }
};
